import { FormEditProfile } from "../../../molecules/forms/FormEditProfile"

export const ViewEditProfileUser = () => {
    return (

        <FormEditProfile/>
    )
}